export default __webpack_public_path__ + "static/media/85.56eb1f04.jpg";